// extracted by mini-css-extract-plugin
export var aircallIframe = "_gi-3";
export var fabContainer = "_gi-5";
export var fabRinging = "_gi-6";
export var loadingOverlay = "_gi-4";
export var pulse = "_gi-7";
export var widgetContent = "_gi-2";
export var widgetPanel = "_gi-0";
export var widgetPanelExpanded = "_gi-1";